import { render, staticRenderFns } from "./TIBC.vue?vue&type=template&id=e77f00e0&scoped=true&"
import script from "./TIBC.vue?vue&type=script&lang=js&"
export * from "./TIBC.vue?vue&type=script&lang=js&"
import style0 from "./TIBC.vue?vue&type=style&index=0&id=e77f00e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77f00e0",
  null
  
)

export default component.exports